import React from "react";

const Body = ({ children }) => {
  return <div className="page-wrapper">{children}</div>;
};

export default Body;
